<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="4" :sm="24">
            <a-form-item label="名称">
              <a-input v-model="queryParam.name" placeholder="请输入名称" allow-clear @keyup.enter.native="$refs.table.refresh(true)"/>
            </a-form-item>
          </a-col>
          <!--          <a-col :md="4" :sm="24">
            <a-form-item label="是否售卖">
              <a-switch v-model="queryParam.is_sale" placeholder="请输入名称" allow-clear/>
            </a-form-item>
          </a-col>-->
          <a-col :md="4" :sm="24">
            <a-form-item label="编号">
              <a-input v-model="queryParam.code" placeholder="请输入完整的编号" allow-clear @keyup.enter.native="$refs.table.refresh(true)"/>
            </a-form-item>
          </a-col>
          <a-col :md="2" :sm="24">
            <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      ref="table"
      size="middle"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :data="loadData"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <div slot="rate_count_render" slot-scope="text" style="text-align: right; min-width: 70px; max-width: 80px">
        {{ text }}
      </div>
      <div slot="money_render" slot-scope="text" style="text-align: right; min-width: 90px; max-width: 100px">
        {{ (text / 100).toFixed(2) }}
      </div>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" v-if="record.is_sale"/>
          <a-popconfirm
            v-if="record.is_sale"
            title="确定要停售么？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelet(record)"
          >
            <a>停售</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>
    <create-form
      ref="createModal"
      :visible="visible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleAddCancel"
      @ok="handleOk"
    />
  </div>
</template>

<script>
import moment from 'moment'
import { STable } from '@/components'
import { Dictionaries } from '@/common/AllConstant'
import CreateForm from '../modules/CreateForm'

import {
  exhibition_goods_create,
  exhibition_goods_delete,
  exhibition_goods_list
} from '@/api/exhibition_goods'

export default {
  name: 'TableList',
  components: {
    STable,
    CreateForm
  },
  data () {
    return {
      loading: false,
      confirmLoading: false,
      current_bill_id: 0,
      // 创建窗口控制
      visible: false,
      mdl: {},
      payconfirmLoading: false,
      // 创建窗口控制
      payvisible: false,
      paymdl: {},
      dictionaries: Dictionaries,
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          align: 'center',
          width: '50px',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '名称',
          dataIndex: 'name'
        },
        {
          title: '编号',
          dataIndex: 'code'
        },
        {
          title: '比率',
          dataIndex: 'rate',
          align: 'center',
          scopedSlots: { customRender: 'rate_count_render' }
        },
        {
          title: '单位',
          align: 'center',
          dataIndex: 'bonded_unit'
        },
        {
          title: '展示单位',
          align: 'center',
          dataIndex: 'exhibition_unit'
        },
        {
          title: '标价',
          dataIndex: 'tag_price',
          align: 'center',
          scopedSlots: { customRender: 'money_render' }
          // customRender: (text) => (text / 100).toFixed(2)
        },
        {
          title: '售价',
          dataIndex: 'sales_price',
          align: 'center',
          scopedSlots: { customRender: 'money_render' }
          // customRender: (text) => (text / 100).toFixed(2)
        },
        {
          title: '展示总数量',
          align: 'center',
          dataIndex: 'total_exhibition_count',
          scopedSlots: { customRender: 'rate_count_render' }
        },
        {
          title: '是否售卖',
          align: 'center',
          dataIndex: 'is_sale',
          customRender: (text) => text ? '是' : '否'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: '350px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('电费参数', parameter)
        return exhibition_goods_list(Object.assign(parameter, this.queryParam))
          .then(({ data }) => {
            return data
          })
      }
    }
  },
  created () {},
  methods: {
    time (dates, dateStrings) {
      this.queryParam.start_time = dateStrings[0]
      this.queryParam.end_time = dateStrings[1]
    },
    getCurrentStyle (current, today) {
      const style = {}
      if (current.date() === 1) {
        style.border = '1px solid #1890ff'
        style.borderRadius = '50%'
      }
      return style
    },
    handleAdd () {
      this.mdl = null
      this.visible = true
    },
    handleAddCancel () {
      this.visible = false
      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handlePayCancel () {
      this.payvisible = false
      const form = this.$refs.createPayModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleEdit (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/exhibition/goods/' + record.id })
    },
    handleUpdate (record) {
      console.log(record)
      this.current_bill_id = record.id
      this.payvisible = true
    },
    handleDelet (record) {
      exhibition_goods_delete(record.id).then((res) => {
        this.$refs.table.refresh()
      })
      .catch((err) => {
        console.log(err)
        this.$message.error('网络出错,请联系管理员')
      })
    },
    handleOk () {
      const form = this.$refs.createModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          // 新增
          values.tag_price = Math.round(values.tag_price * 100)
          values.sales_price = Math.round(values.sales_price * 100)
          values.cost = Math.round(values.cost * 100)
          exhibition_goods_create(values).then(res => {
              this.visible = false
              this.confirmLoading = false
              // 重置表单数据
              form.resetFields()
              // 刷新表格
              this.$refs.table.refresh()
            })
            .catch((err) => {
              console.log(err)
              this.confirmLoading = false
            })
        } else {
          this.confirmLoading = false
        }
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },

    resetSearchForm () {
      this.queryParam = {
        date: moment(new Date())
      }
    }
  }
}
</script>
